<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-2">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-cube text-white"></i>
          </div>
          <div class="header-text-container">
            <h5 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Produtos</h5>
            <p class="text-muted mb-0 small">Pesquisa e gestão de produtos</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-2">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir/HTML">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-text-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-input 
                        type="text" 
                        ref="edDescricao"
                        v-model="descricao" 
                        placeholder="Descrição..." 
                        class="border-0 bg-transparent" 
                        style="width: 200px" 
                        @keydown.enter="pesquisar()" 
                    />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white"  @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Adicionar</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-3 pb-2">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row>
                    <b-col sm="2">
                      <label class="small font-weight-bold text-muted mb-1">Código</label>
                      <b-form-input type="text" id="codigo" placeholder="Código" v-model="id" @keydown.enter="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                      <label class="small font-weight-bold text-muted mb-1">Código Barras EAN13</label>
                      <b-form-input type="text" id="ean" placeholder="Cod. barras" v-model="ean" @keydown.enter="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                      <label class="small font-weight-bold text-muted mb-1">Grupo de Produtos</label>
                      <b-form-input type="text" id="edGrupoProduto" placeholder="Informe o Grupo" v-model="grupoId" @keydown.enter="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col sm="3" class="d-flex align-items-center pt-3">
                      <b-form-checkbox v-model="exibirInativos" @change="pesquisar()" name="check-inativos" switch>
                        <span class="small font-weight-bold" :class="exibirInativos ? 'text-primary' : 'text-muted'">Exibir Inativos</span>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
              class="mb-0 table-finance"
              id="table-produtos"
              ref="tbl"
              :items="itensFiltrados"
              :fields="fieldsListagem"
              :per-page="perPage"
              :current-page="currentPage"
              :sticky-header="stickyHeight"
              :tbody-tr-class="rowClassSelecionado"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              hover 
              small 
              bordered 
              @row-clicked="clicarLinha"
              @row-dblclicked="edit"
              show-empty
              empty-text="Informe o filtro para ver os registros "
              responsive 
            >
                  
              <template #head(CODIGO)>
                <SetFilter
                  label="CODIGO"
                  v-model="filtros.CODIGO"
                  :options="opcoes.CODIGO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(DESCRICAO)>
                <SetFilter
                  label="Descricao"
                  v-model="filtros.DESCRICAO"
                  :options="opcoes.DESCRICAO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(REZUMIDO)>
                <SetFilter
                  label="Resumido"
                  v-model="filtros.REZUMIDO"
                  :options="opcoes.REZUMIDO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(EAN)>
                <SetFilter
                  label="EAN"
                  v-model="filtros.EAN"
                  :options="opcoes.EAN"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(TX_NCM)>
                <SetFilter
                  label="NCM"
                  v-model="filtros.TX_NCM"
                  :options="opcoes.TX_NCM"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(NOME_GRUPO)>
                <SetFilter
                  label="Grupo"
                  v-model="filtros.NOME_GRUPO"
                  :options="opcoes.NOME_GRUPO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(NOME_SUBGRUPO)>
                <SetFilter
                  label="Sub-grupo"
                  v-model="filtros.NOME_SUBGRUPO"
                  :options="opcoes.NOME_SUBGRUPO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
               <template #head(OP_COFINS_SITUACAO_TRIBUTARIA)>
                <SetFilter
                  label="Cofins"
                  v-model="filtros.OP_COFINS_SITUACAO_TRIBUTARIA"
                  :options="opcoes.OP_COFINS_SITUACAO_TRIBUTARIA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
               <template #head(OP_PIS_SITUACAO_TRIBUTARIA)>
                <SetFilter
                  label="PIS"
                  v-model="filtros.OP_PIS_SITUACAO_TRIBUTARIA"
                  :options="opcoes.OP_PIS_SITUACAO_TRIBUTARIA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(OP_ICMS_SITUACAO_TRIBUTARIA)>
                <SetFilter
                  label="ICMS CST"
                  v-model="filtros.OP_ICMS_SITUACAO_TRIBUTARIA"
                  :options="opcoes.OP_ICMS_SITUACAO_TRIBUTARIA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #cell(CODIGO)="data">
                <div class="d-flex align-items-center">
                  <span :class="{'text-muted font-italic': data.item.OP_SITUACAO === '0'}">{{ data.value }}</span>
                  <b-badge v-if="data.item.OP_SITUACAO === '0'" variant="secondary" pill class="ml-2 small shadow-xs">INATIVO</b-badge>
                </div>
              </template>

              <template #cell(DESCRICAO)="data">
                <span :class="{'text-muted font-italic opacity-50': data.item.OP_SITUACAO === '0'}">{{ data.value }}</span>
              </template>

              <template #cell(OP_SITUACAO)="data">
                <b-badge :variant="data.value === '1' ? 'success' : 'danger'" pill class="px-2 shadow-xs" style="font-size: 0.65rem;">
                  {{ data.value === '1' ? 'ATIVO' : 'INATIVO' }}
                </b-badge>
              </template>

              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              <template #cell(actions)="item">
                <div class="d-flex align-items-center gap-1 justify-content-end">
                  <b-button type="button" @click.stop.prevent="copiarProduto(item.item)" variant="soft-info" pill class="btn-icon-only shadow-sm" title="Copiar Produto" v-b-tooltip.hover>
                    <i class="fa fa-copy"></i>
                  </b-button>
                  <b-button type="button" @click.stop="deleteProduto(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-times"></i>
                  </b-button>
                </div>
              </template>

              <template #custom-foot="{ fields }">
                <b-tr>
                  <b-td class="font-weight-bold">Total: ({{ itensFiltrados.length }})</b-td>
                  <b-td :colspan="fields.length - 1"></b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
    
    <!-- Modal de Confirmação para Resultados Grandes -->
    <b-modal 
      ref="modalConfirmarResultadoGrande"
      id="modal-confirmar-resultado-grande"
      title="Resultado da Pesquisa"
      header-bg-variant="warning"
      header-text-variant="dark"
      centered
      @ok="confirmarCarregarResultadoGrande"
      @cancel="cancelarCarregarResultadoGrande"
      @shown="onModalShown"
      @hidden="onModalHidden"
      cancel-variant="secondary"
    >
      <div class="text-center">
        <b-icon icon="exclamation-triangle" variant="warning" font-scale="3"></b-icon>
        <h5 class="mt-3">Atenção!</h5>
        <p class="mb-2">
          A pesquisa retornou <strong>{{ resultadoPendenteCount }} registros</strong>.
        </p>
        <p class="mb-0">
          Isso pode deixar o sistema lento.
        </p>
        <p class="mt-3">
          <strong>Deseja continuar mesmo assim?</strong>
        </p>
      </div>
      
      <template #modal-footer="{ cancel, ok }">
        <b-button 
          ref="btnCancelar"
          variant="secondary" 
          @click="cancel()"
        >
          <b-icon icon="x-circle" aria-hidden="true"></b-icon> Não, cancelar [ESC]
        </b-button>
        <b-button 
          variant="primary" 
          @click="ok()"
        >
          <b-icon icon="check-circle" aria-hidden="true"></b-icon> Sim, carregar dados
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import cSwitch from '../../../components/Switch'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import Tools from '@/tools/tools.js'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'

export default {
  components: {
    VueButtonSpinner,
    cSwitch,
    SetFilter,
    ModalAlertaResultadoGrande
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'CODIGO', type: 'number', label: 'ID' },
      { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
      { key: 'REZUMIDO', type: 'string', label: 'Resumido' },
      { key: 'EAN', type: 'string', label: 'EAN' },
      { key: 'TX_NCM', type: 'string', label: 'NCM' },
      { key: 'NOME_GRUPO', type: 'string', label: 'Grupo' },
      { key: 'NOME_SUBGRUPO', type: 'string', label: 'Sub-Grupo' },
      { key: 'OP_COFINS_SITUACAO_TRIBUTARIA', type: 'string', label: 'COFINS' },
      { key: 'OP_PIS_SITUACAO_TRIBUTARIA', type: 'string', label: 'PIS' },
      { key: 'OP_ICMS_SITUACAO_TRIBUTARIA', type: 'string', label: 'ICMS CST' }
    ]
  })],

  data () {
    return {
      isBusy: false,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      modalDetails: { index: '', data: '' }
    }
  },
  
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    // Cada tabela constrói sua própria rowFilter a partir da sua config
    fieldsListagem: {
      get () {
        return this.$store.getters['produto/FIELDS']
      }, 
      set (value) {
        this.$store.commit("produto/SET_FIELDS", value);
      }
    },
    filtroCabecalho: {
      get () {
        return this.$store.getters['produto/FILTRO_CABECALHO']
      }, 
      set (value) {
        this.$store.commit("produto/SET_FILTRO_CABECALHO", value);
      }
    },
    currentPage: {
      get () {
        return this.$store.getters['produto/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("produto/SET_PAGINA_ATUAL", value);
      }
    },
    filtroAvancado: {
      get () {
        return this.$store.getters['produto/FILTRO_AVANCADO']
      }, 
      set (value) {
        this.$store.commit("produto/SET_FILTRO_AVANCADO", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['produto/PER_PAGE']
      }, 
      set (value) {
        this.$store.commit("produto/SET_PER_PAGE", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['produto/ID']
      }, 
      set (value) {
        this.$store.commit("produto/SET_ID", value);
      }
    },
    descricao: {
      get () {
        return this.$store.getters['produto/DESCRICAO']
      }, 
      set (value) {
        this.$store.commit("produto/SET_DESCRICAO", value);
      }
    },
    ean: {
      get () {
        return this.$store.getters['produto/EAN']
      }, 
      set (value) {
        this.$store.commit("produto/SET_EAN", value);
      }
    },
    grupoId: {
      get () {
        return this.$store.getters['produto/GRUPO_ID']
      }, 
      set (value) {
        this.$store.commit("produto/SET_GRUPO_ID", value);
      }
    },
    exibirInativos: {
      get () {
        return this.$store.getters['produto/EXIBIR_INATIVOS']
      }, 
      set (value) {
        this.$store.commit("produto/SET_EXIBIR_INATIVOS", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['produto/LISTA']
      }, 
      set (value) {
        this.$store.commit("produto/SET_LISTA", value);
      }
    }
  },
  methods: {


    limparFiltros() {
      this.teste.filtros = { nome: '', cidade: '', status: '' }
    },
    async deleteProduto(item) {
      const confirm = await this.$bvModal.msgBoxConfirm(`Deseja realmente excluir o produto: ${item.DESCRICAO}?`, {
        title: 'Confirmar Exclusão',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })

      if (confirm) {
        try {
          this.$store.commit('controle/setAguardando', true)
          const { data } = await this.$http.delete(`/api/protected/produto/delete/${item.CODIGO}`)
          
          if (data.status === 'sucesso') {
            Tools.exibirMensagem(this.$store, 'Sucesso', 'success', data.message)
            await this.pesquisar()
          } else {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', data.message || 'Não foi possível excluir o produto.')
          }
        } catch (err) {
          console.error(err)
          const errorMsg = err.response?.data || err.message || 'Erro ao excluir produto.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', errorMsg)
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      }
    },
    async copiarProduto(item) {
      const msg = await this.$bvModal.msgBoxConfirm(`Copiar o Produto: ${item.DESCRICAO} ?`, {
          title: 'Copiar',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'success',
          okTitle: 'SIM',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        
        if (msg == false) return   

        try {
          this.$store.commit('controle/setAguardando', true)
          
          const {data} = await this.$http.post(`/api/protected/produto/copiar`, {id: item.CODIGO})

          if (!data || !data.id) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel copiar!')
            return
          }

          this.$store.commit("produto/SET_LIMPAR", null)
          this.$store.commit("produto/SET_REGISTRO_SELECIONADO_ID", data.id)
          this.$store.commit("produto/SET_ID", data.id)
          this.$store.commit('produto/SET_PAGINA_ATUAL', 1)
          await this.$store.dispatch('produto/GET_LISTA')
          this.$store.commit("produto/SET_LIMPAR_APENAS_FILTRO", null) // limpar o filtro pq ja localizou o registro novo 
          
          this.$router.push(`/cadastros/produto/edit/${data.id}`)

        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel copiar!')
          return
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
    },

  /*************************************************************************** */
    clicarLinha(item) {
      this.$store.commit("produto/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['produto/REGISTRO_SELECIONADO_ID']
      return item.CODIGO === selId ? 'cec-row-selected' : ''
    },
    colorirSituacao(item) { 
      return item.OP_SITUACAO_FINANCEIRO === '0' ? 'success' : 'danger'
    },

    traduzirSituacao(item) { 
      return item.OP_SITUACAO_FINANCEIRO === '0' ? 'LIBERADO' : 'BLOQUEADO'
    },
    formatarCampo(campoTexto) {
      if (campoTexto.value.length <= 11) {
          campoTexto.value = this.mascaraCpf(campoTexto.value)
      } else {
          campoTexto.value = this.mascaraCnpj(campoTexto.value)
      }
    },
    retirarFormatacao(campoTexto) {
      // Verifica se campoTexto é nulo ou undefined
      if   ((!campoTexto) 
        || (!(campoTexto instanceof HTMLElement)) 
        || (!campoTexto.hasOwnProperty('value')) 
        || (typeof campoTexto.value !== 'string')) {
        return
      }

      // Remove formatação
      campoTexto.value = campoTexto.value.replace(/(\.|\/|\-)/g, "");
    },
    mascaraCpfCgc(item) {
      if (item.CGC && typeof item.CGC === 'string') {
        return this.formatarCnpjCpf(item.CGC)
      }
      return null
    },
    formatarCnpjCpf(texto) {
      // Remove todos os caracteres que não são números
      const numeros = texto.replace(/\D/g, '');

      // Verifica se é CNPJ (14 dígitos) ou CPF (11 dígitos)
      const cnpjCpfFormatado = numeros.length === 14 ?
        numeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : // CNPJ
        numeros.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4'); // CPF

      return cnpjCpfFormatado;
    },
    colorirStatus(item) { 
      if (item.STATUS == 'ATIVO') return 'success'
      else 'danger'
    },
    colorirStatusTipoCliente(linha) { 
      let cliente = '0'
      let fornecedor = '0'
      if (linha.OP_CLIENTE && typeof linha.OP_CLIENTE === 'string') {
          cliente = linha.OP_CLIENTE.trim()
      }

      if (linha.OP_FORNECEDOR && typeof linha.OP_FORNECEDOR === 'string') {
          fornecedor = linha.OP_FORNECEDOR.trim()
      }

      if (cliente == '1' && fornecedor == '0') return 'success'
      else if (cliente == '0' && fornecedor == '1') return 'info'
      else if (cliente == '1' && fornecedor == '1') return 'gray-300'
      else 'info'
    },
    traduzirSituacaoTipoCliente(linha) { 
      let cliente = '0'
      let fornecedor = '0'
      if (linha.OP_CLIENTE && typeof linha.OP_CLIENTE === 'string') {
          cliente = linha.OP_CLIENTE.trim()
      }

      if (linha.OP_FORNECEDOR && typeof linha.OP_FORNECEDOR === 'string') {
          fornecedor = linha.OP_FORNECEDOR.trim()
      }

      if (cliente == '1' && fornecedor == '0') return 'CLIENTE'
      else if (cliente == '0' && fornecedor == '1') return 'FORNECEDOR'
      else if (cliente == '1' && fornecedor == '1') return 'produto/FORNECEDOR'
      else return ''
    },
    traduzirIsento(linha) {
      if (linha.ISENTO_ICMS && typeof linha.ISENTO_ICMS === 'string') {
        if (linha.ISENTO_ICMS.trim() == '0'|| linha.ISENTO_ICMS.trim() == '' ) return 'ISENTO'
        else if (linha.ISENTO_ICMS.trim() == '1') return 'SUJEITO'
      }
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        reportTitle: 'Listagem de Produtos',
        printedBy: window.localStorage.getItem('login') ?? '—',
        columns: this.fieldsListagem,
        filename: 'produtos.html',
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.fieldsListagem,
        filename: 'produtos.xlsx',
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fieldsListagem,
        filename: 'produtos.csv',
      });
    },
    limparFiltro() {
      this.$store.commit("produto/SET_LIMPAR", null)
    },
    details (item) {
      alert(JSON.stringify(item.CODIGO))
    },
    edit (item) {
      this.$store.commit("produto/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
      this.$router.push(`/cadastros/produto/edit/${item.CODIGO}`)
    },
    novo () {
      this.$router.push(`/cadastros/produto/add`)
    },
    async pesquisar () {
      // Previne pesquisa se o modal de confirmação estiver aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      this.isBusy = true
      this.$store.commit('controle/setAguardando', true)
      
      try {
        const resultado = await this.$store.dispatch('produto/GET_LISTA')
        
        // Verifica se precisa de confirmação
        if (resultado.needsConfirmation) {
          // Fecha o aguardando antes de exibir o modal
          this.$store.commit('controle/setAguardando', false)
          this.isBusy = false
          
          // Armazena os dados para uso posterior
          this.resultadoPendente = resultado.data
          this.resultadoPendenteCount = resultado.count
          
          // Remove o foco do input antes de abrir o modal
          if (this.$refs.edDescricao) {
            this.$refs.edDescricao.blur()
          }
          
          // Exibe o modal de confirmação
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
        // Resultado carregado normalmente
        if (this.$store.getters['produto/REGISTRO_SELECIONADO_ID']) {
          this.scrollToSelected()
        }
      } catch(err) {
        this.lista = []
        
        let msg 
        if (err.response && err.response.status) {
          msg = err.response.data
          Tools.exibirMensagem(this.$store, 'Falha', 'warning', msg)
        } else {
          Tools.exibirMensagem(this.$store, 'Falha', 'danger', `Falha ao pesquisar: ${err.message}`)
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.isBusy = false
        this.$nextTick(() => {
          this.$refs.edDescricao?.focus()
        })
      }
    },
    async confirmarCarregarResultadoGrande() {
      // Reabre o aguardando
      this.isBusy = true
      this.$store.commit('controle/setAguardando', true)
      
      try {
        // Carrega os dados que estavam pendentes, pulando a confirmação
        await this.$store.dispatch('produto/GET_LISTA', { skipConfirmation: true })

        if (this.$store.getters['produto/REGISTRO_SELECIONADO_ID']) {
          this.scrollToSelected()
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao carregar os registros: ' + err.message)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.isBusy = false
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
        this.$nextTick(() => {
          this.$refs.edDescricao?.focus()
        })
      }
    },
    cancelarCarregarResultadoGrande() {
      // Limpa os dados pendentes
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Pesquisa cancelada. Refine os filtros para reduzir o resultado.')
      this.$nextTick(() => {
        this.$refs.edDescricao?.focus()
      })
    },
    onModalShown() {
      this.modalConfirmacaoAberto = true
    },
    onModalHidden() {
      this.modalConfirmacaoAberto = false
    },
    scrollToSelected() {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.cec-row-selected')
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 300)
      })
    },
    handleKeydown(event) {
      // Não executa ações se o modal estiver aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.novo()
      } 
    }
  },
  mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
    }, 200)
    
    this.$nextTick(() => {
      this.$refs.edDescricao?.focus()
    })

    // Se já houver lista, tenta scrollar para o selecionado
    if (this.lista && this.lista.length > 0) {
      this.scrollToSelected()
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
  },
}
</script>
<style scoped>
/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6  !important;
  color: #000000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6  !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #c2cfd6  !important;
}

/* Table Enhancements */
.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 4px 6px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 2px 6px !important;
  color: #4a5568;
  font-size: 0.8rem;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.header-icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.shadow-xs {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
</style>




// WEBPACK FOOTER //
// src/views/cadastros/produtos/ProdutosListagem.vue